import { createGlobalStyle } from 'styled-components';
export const BodyBackgroundStyles = createGlobalStyle(({
  theme
}) => ({
  'html body': {
    backgroundColor: theme.color['fill-surface-recessed']
  }
}));